import React, { useState, useEffect } from "react";
import CryptoTravel from "../../Assets/Projects/CryptoTravel.png";
import Cobber from "../../Assets/Projects/Cobber.png";
import CobberDriver from "../../Assets/Projects/CobberDriver.png";
import Bondex from "../../Assets/Projects/Bondex.png";
import Pirayo from "../../Assets/Projects/pirayo2.png";
import Peaueclat from "../../Assets/Projects/Peaueclat.png";

const projects = [
  {
    id: 1,
    title: "Crypto Travels",
    category: "Travel · Booking Platform",
    description:
      "Engineered a scalable flight booking platform enabling real-time search, price comparison, and reservation management with integrated secure payment processing. The system was architected to handle high-concurrency booking flows while maintaining a fast, reliable user experience — reducing friction in the customer journey and supporting operational efficiency at scale.",
    tech: ["Next.js", "Node.js", "Express.js", "Stripe", "Redis", "MongoDB", "Railway", "Vercel"],
    links: [{ label: "Visit Platform", url: "https://cryptotravels.co.uk/", icon: "web" }],
    visual: "CT",
    color: "#1E3A5F",
    accent: "#4A90D9",
    pattern: "grid",
    image: CryptoTravel,
    imageBlend: false,
    imageFit: "cover",
    isDelivered: false,
  },
  {
    id: 2,
    title: "Cobber",
    category: "Logistics · Consumer Mobile",
    description:
      "Built a peer-to-peer logistics platform that simplifies transportation of large second-hand items through real-time delivery tracking, driver coordination, and secure payment workflows. The platform improved operational transparency across the buyer, seller, and driver network — reducing coordination overhead and delivering a reliable, end-to-end logistics experience.",
    tech: ["React Native", "Google Maps", "Live Tracking", "Socket.IO", "Push Notifications", "Stripe"],
    links: [
      { label: "App Store", url: "https://apps.apple.com/gb/app/cobber/id6444457781", icon: "apple" },
      { label: "Play Store", url: "https://play.google.com/store/apps/details?id=com.cobber", icon: "android" },
    ],
    visual: "CB",
    color: "#0D2017",
    accent: "#3AB07A",
    pattern: "circles",
    image: Cobber,
    imageBlend: false,
    imageFit: "contain",
    isDelivered: false,
  },
  {
    id: 3,
    title: "Cobber Driver",
    category: "Logistics · Driver Operations",
    description:
      "Developed the driver-side logistics application enabling delivery partners to manage routes, track jobs in real time, receive live trip updates, and process earnings efficiently. Designed to support scalable driver operations across a distributed network, with a focus on reducing dispatch friction and improving delivery coordination.",
    tech: ["React Native", "Google Maps", "Live Tracking", "Socket.IO", "Push Notifications", "Stripe"],
    links: [
      { label: "App Store", url: "https://apps.apple.com/gb/app/cobber-driver/id6444460120", icon: "apple" },
      { label: "Play Store", url: "https://play.google.com/store/apps/details?id=com.cobberdriver", icon: "android" },
    ],
    visual: "CD",
    color: "#130D22",
    accent: "#8B5CF6",
    pattern: "lines",
    image: CobberDriver,
    imageBlend: false,
    imageFit: "contain",
    isDelivered: false,
  },
  {
    id: 4,
    title: "Bondex",
    category: "Professional Networking · Mobile",
    description:
      "Contributed to the development of a mobile-first professional networking platform focused on modernizing talent discovery, referral-based recruitment, and community-driven career growth. Delivered scalable social engagement features, monetized referral workflows, and seamless cross-platform mobile experiences for a growing international professional user base.",
    tech: ["React Native", "Expo", "React.js", "Firebase", "Stripe", "Social Media APIs"],
    links: [
      { label: "App Store", url: "https://apps.apple.com/pk/app/bondex-origin/id1579045181", icon: "apple" },
      { label: "Play Store", url: "https://play.google.com/store/apps/details?id=com.bondex.origin", icon: "android" },
    ],
    visual: "BX",
    color: "#0B1A20",
    accent: "#F59E0B",
    pattern: "dots",
    image: Bondex,
    imageBlend: false,
    imageFit: "cover",
    isDelivered: true,
  },
  {
    id: 5,
    title: "Pirayo",
    category: "Ride-Hailing · Mobility",
    description:
      "Built a scalable ride-hailing platform integrating live location tracking, real-time trip updates, and mapping services to optimize transportation workflows and rider-driver coordination. The platform focused on delivering a reliable, efficient, and user-friendly mobility experience with infrastructure designed to support growth across multiple cities.",
    tech: ["React Native", "Google Maps", "Live Tracking", "Socket.IO", "Push Notifications", "Stripe"],
    links: [{ label: "Play Store", url: "https://play.google.com/store/apps/details?id=com.pirayo", icon: "android" }],
    visual: "PR",
    color: "#1A1600",
    accent: "#D4B000",
    pattern: "wave",
    image: Pirayo,
    imageBlend: false,
    imageFit: "cover",
    isDelivered: true,
  },
  {
    id: 6,
    title: "Custom Metal Cards",
    category: "E-Commerce · Personalization",
    description:
      "Developed a card personalization platform enabling users to transform standard debit and credit cards into premium branded metal and wooden cards through an interactive customization experience. The system integrated secure payment processing, order tracking, and streamlined fulfillment workflows to deliver a premium end-to-end ordering experience.",
    tech: ["Next.js", "React", "Firebase", "Stripe"],
    links: [],
    visual: "MC",
    color: "#111111",
    accent: "#D4AF37",
    pattern: "grid",
    image: Peaueclat,
    imageBlend: false,
    imageFit: "cover",
    isDelivered: true,
  },
];

const PatternBg = ({ pattern, accent }) => {
  const opacity = 0.12;
  if (pattern === "grid")
    return (
      <svg style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity }} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id={`grid-${accent}`} width="40" height="40" patternUnits="userSpaceOnUse">
            <path d="M 40 0 L 0 0 0 40" fill="none" stroke={accent} strokeWidth="0.8" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#grid-${accent})`} />
      </svg>
    );
  if (pattern === "circles")
    return (
      <svg style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity }} xmlns="http://www.w3.org/2000/svg">
        {[60, 120, 180, 240].map((r, i) => (
          <circle key={i} cx="50%" cy="50%" r={r} fill="none" stroke={accent} strokeWidth="0.8" />
        ))}
      </svg>
    );
  if (pattern === "dots")
    return (
      <svg style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity }} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id={`dots-${accent}`} width="24" height="24" patternUnits="userSpaceOnUse">
            <circle cx="2" cy="2" r="1.5" fill={accent} />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#dots-${accent})`} />
      </svg>
    );
  if (pattern === "lines")
    return (
      <svg style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity }} xmlns="http://www.w3.org/2000/svg">
        {Array.from({ length: 12 }).map((_, i) => (
          <line key={i} x1={i * 48} y1="0" x2={i * 48} y2="100%" stroke={accent} strokeWidth="0.8" />
        ))}
      </svg>
    );
  if (pattern === "wave")
    return (
      <svg style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice">
        {[0, 40, 80, 120, 160].map((offset, i) => (
          <path key={i} d={`M0,${80 + offset} C100,${40 + offset} 300,${120 + offset} 400,${80 + offset}`} fill="none" stroke={accent} strokeWidth="0.8" />
        ))}
      </svg>
    );
  return null;
};

const AppleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98l-.09.06c-.22.15-2.13 1.26-2.11 3.75.03 2.98 2.61 3.97 2.64 3.98-.03.07-.41 1.4-1.38 2.84M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

const AndroidIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z" />
  </svg>
);

const WebIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z" />
  </svg>
);

const LinkButton = ({ link, accent }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <a
      href={link.url}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontSize: 13,
        fontWeight: 600,
        color: hovered ? "#FFFFFF" : "rgba(255,255,255,0.85)",
        background: hovered ? `${accent}22` : "rgba(255,255,255,0.07)",
        border: `1px solid ${hovered ? accent + "55" : "rgba(255,255,255,0.12)"}`,
        borderRadius: 8,
        padding: "10px 18px",
        textDecoration: "none",
        letterSpacing: 0.3,
        transition: "all 0.2s ease",
        cursor: "pointer",
      }}
    >
      {link.icon === "apple" && <AppleIcon />}
      {link.icon === "android" && <AndroidIcon />}
      {link.icon === "web" && <WebIcon />}
      {link.label}
    </a>
  );
};

function ProjectVisual({ project }) {
  const [hovered, setHovered] = useState(false);
  const hasImage = !!project.image;

  return (
    <div
      className="project-visual"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        flex: "0 0 480px",
        height: 360,
        borderRadius: 16,
        background: project.color,
        position: "relative",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid rgba(255,255,255,0.08)",
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        transition: "transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s ease",
        boxShadow: hovered ? `0 32px 80px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.1), 0 0 60px ${project.accent}22` : "0 8px 40px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.06)",
        cursor: "default",
      }}
    >
      <PatternBg pattern={project.pattern} accent={project.accent} />

      {hasImage ? (
        <>
          <img
            src={project.image}
            alt={project.title}
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: project.imageFit || "cover",
              objectPosition: "center",
              mixBlendMode: project.imageBlend ? "multiply" : "normal",
              transform: hovered ? "scale(1.03)" : "scale(1)",
              transition: "transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)",
              filter: project.imageBlend ? "none" : "brightness(0.88) contrast(1.04)",
            }}
          />
          {!project.imageBlend && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: "linear-gradient(to top, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.0) 50%)",
                pointerEvents: "none",
              }}
            />
          )}
          {project.imageBlend && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: `${project.color}CC`,
                mixBlendMode: "color",
                pointerEvents: "none",
              }}
            />
          )}
        </>
      ) : (
        <span
          style={{
            fontFamily: "'Ubuntu', sans-serif",
            fontSize: 96,
            fontWeight: 700,
            color: project.accent,
            opacity: hovered ? 0.22 : 0.14,
            letterSpacing: -4,
            userSelect: "none",
            zIndex: 1,
            position: "relative",
            transition: "opacity 0.4s ease",
          }}
        >
          {project.visual}
        </span>
      )}

      {/* Top accent line */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          background: `linear-gradient(90deg, ${project.accent}, transparent)`,
          zIndex: 2,
        }}
      />

      {/* Category label */}
      <div
        style={{
          position: "absolute",
          top: 20,
          left: 20,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontSize: 10,
          fontWeight: 600,
          color: hasImage && !project.imageBlend ? "#FFFFFF" : project.accent,
          letterSpacing: 2,
          textTransform: "uppercase",
          opacity: hasImage && !project.imageBlend ? 0.7 : 0.8,
          zIndex: 2,
          textShadow: hasImage && !project.imageBlend ? "0 1px 4px rgba(0,0,0,0.6)" : "none",
        }}
      >
        {project.category.split("·")[0].trim()}
      </div>

      {/* Status indicator */}
      <div
        style={{
          position: "absolute",
          bottom: 20,
          right: 20,
          display: "flex",
          alignItems: "center",
          gap: 6,
          zIndex: 2,
        }}
      >
        <div
          style={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            background: project.accent,
            opacity: hovered ? 1 : 0.6,
            transition: "opacity 0.3s ease",
            boxShadow: hovered ? `0 0 8px ${project.accent}` : "none",
          }}
        />
        <span
          style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontSize: 10,
            color: hasImage && !project.imageBlend ? "rgba(255,255,255,0.7)" : "rgba(255,255,255,0.3)",
            letterSpacing: 1.5,
            textShadow: hasImage && !project.imageBlend ? "0 1px 4px rgba(0,0,0,0.8)" : "none",
          }}
        >
          {!project.isDelivered ? "LIVE" : "DELIVERED"}
        </span>
      </div>
    </div>
  );
}

export default function Work() {
  const [scrollY, setScrollY] = useState(0);
  const [navHover, setNavHover] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { label: "Home", href: "/" },
    { label: "Work", href: "/work" },
    { label: "Services", href: "/#services" },
    { label: "Contact", href: "/#contact" },
  ];

  return (
    <div style={{ background: "#0A0F1A", minHeight: "100vh", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@300;400;500;700&family=Plus+Jakarta+Sans:wght@300;400;500;600;700&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        html { scroll-behavior: smooth; }
        body { background: #0A0F1A; }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .anim-fade-up-1 { animation: fadeUp 0.9s cubic-bezier(0.16,1,0.3,1) both; animation-delay: 0.1s; }
        .anim-fade-up-2 { animation: fadeUp 0.9s cubic-bezier(0.16,1,0.3,1) both; animation-delay: 0.25s; }
        .anim-fade-up-3 { animation: fadeUp 0.9s cubic-bezier(0.16,1,0.3,1) both; animation-delay: 0.4s; }
        .anim-fade-in   { animation: fadeIn 1.2s ease both; animation-delay: 0.6s; }

        .cta-btn {
          display: inline-flex; align-items: center; gap: 8px;
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; font-weight: 600;
          color: #0A0F1A; background: #FFFFFF; border: none; border-radius: 8px;
          padding: 12px 24px; text-decoration: none; letter-spacing: 0.3px;
          transition: all 0.2s ease; cursor: pointer;
        }
        .cta-btn:hover { background: #EEF2F7; transform: translateY(-1px); }

        .menu-btn { display: none !important; }

        .mobile-menu {
          display: none; position: fixed; inset: 0;
          background: rgba(10,15,26,0.98); z-index: 999;
          flex-direction: column; align-items: center; justify-content: center; gap: 40px;
        }
        .mobile-menu.open { display: flex !important; }

        @media (max-width: 900px) {
          .nav-links-desktop { display: none !important; }
          .menu-btn { display: flex !important; }
          .project-row {
            flex-direction: column !important;
            gap: 48px !important;
            padding: 0 24px !important;
          }
          .project-visual {
            flex: none !important;
            width: 100% !important;
            max-width: 100% !important;
            height: 260px !important;
          }
          .hero-section-pad { padding: 0 24px !important; }
          .hero-h1 { font-size: 52px !important; }
        }
        @media (max-width: 600px) {
          .hero-h1 { font-size: 38px !important; }
          .project-section { padding: 60px 0 !important; }
        }
      `}</style>

      {/* ── NAVBAR ── */}
      <nav
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          padding: "0 40px",
          height: 68,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: scrollY > 50 ? "rgba(10,15,26,0.95)" : "transparent",
          borderBottom: scrollY > 50 ? "1px solid rgba(255,255,255,0.08)" : "1px solid transparent",
          backdropFilter: scrollY > 50 ? "blur(16px)" : "none",
          transition: "all 0.3s ease",
        }}
      >
        <a href="/" style={{ fontFamily: "'Ubuntu', sans-serif", fontSize: 20, fontWeight: 700, color: "#FFFFFF", textDecoration: "none", letterSpacing: -0.5 }}>
          Resovate<span style={{ color: "#344F6B", fontSize: 12, fontWeight: 400, marginLeft: 4 }}>Labs</span>
        </a>

        <div className="nav-links-desktop" style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onMouseEnter={() => setNavHover(link.label)}
              onMouseLeave={() => setNavHover(null)}
              style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: 14,
                fontWeight: link.label === "Work" ? 600 : 400,
                color: link.label === "Work" ? "#FFFFFF" : navHover === link.label ? "#FFFFFF" : "rgba(255,255,255,0.55)",
                textDecoration: "none",
                padding: "8px 16px",
                borderRadius: 8,
                background: link.label === "Work" ? "rgba(255,255,255,0.08)" : navHover === link.label ? "rgba(255,255,255,0.05)" : "transparent",
                transition: "all 0.2s ease",
              }}
            >
              {link.label}
            </a>
          ))}
          <a href="/#contact" className="cta-btn" style={{ marginLeft: 16 }}>
            Start a Project
          </a>
        </div>

        <button className="menu-btn" onClick={() => setMenuOpen(true)} style={{ background: "none", border: "none", cursor: "pointer", padding: 8, flexDirection: "column", gap: 5 }}>
          {[0, 1, 2].map((i) => (
            <span key={i} style={{ display: "block", width: 24, height: 1.5, background: "#FFFFFF", borderRadius: 2 }} />
          ))}
        </button>
      </nav>

      {/* ── MOBILE MENU ── */}
      <div className={`mobile-menu${menuOpen ? " open" : ""}`}>
        <button
          onClick={() => setMenuOpen(false)}
          style={{ position: "absolute", top: 24, right: 40, background: "none", border: "none", color: "rgba(255,255,255,0.6)", fontSize: 28, cursor: "pointer" }}
        >
          ×
        </button>
        {navLinks.map((link) => (
          <a
            key={link.label}
            href={link.href}
            onClick={() => setMenuOpen(false)}
            style={{ fontFamily: "'Ubuntu', sans-serif", fontSize: 28, fontWeight: 600, color: "#FFFFFF", textDecoration: "none" }}
          >
            {link.label}
          </a>
        ))}
      </div>

      {/* ── HERO ── */}
      <section style={{ paddingTop: 160, paddingBottom: 100, position: "relative", overflow: "hidden" }}>
        {/* bg glow */}
        <div
          style={{
            position: "absolute",
            top: -200,
            right: -200,
            width: 600,
            height: 600,
            background: "radial-gradient(circle, rgba(52,79,107,0.18) 0%, transparent 70%)",
            borderRadius: "50%",
            pointerEvents: "none",
          }}
        />

        {/* centered content column */}
        <div
          className="hero-section-pad anim-fade-up-1"
          style={{
            maxWidth: 860,
            margin: "0 auto",
            padding: "0 40px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* eyebrow row */}
          <div className="anim-fade-up-1" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 16, marginBottom: 32 }}>
            <span style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 11, fontWeight: 600, color: "#344F6B", letterSpacing: 3, textTransform: "uppercase" }}>Selected Work</span>
            <span style={{ width: 40, height: 1, background: "rgba(52,79,107,0.5)", display: "inline-block" }} />
            <span style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 11, color: "rgba(255,255,255,0.3)", letterSpacing: 1.5 }}>{projects.length} Projects</span>
          </div>

          {/* heading */}
          <h1
            className="hero-h1 anim-fade-up-2"
            style={{
              fontFamily: "'Ubuntu', sans-serif",
              fontSize: 72,
              fontWeight: 700,
              color: "#FFFFFF",
              lineHeight: 1.02,
              letterSpacing: -2.5,
              marginBottom: 28,
              textAlign: "center",
            }}
          >
            Selected Work &<br />
            <span style={{ color: "rgba(255,255,255,0.35)" }}>Product Experience.</span>
          </h1>

          {/* subtitle */}
          <p
            className="anim-fade-up-3"
            style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontSize: 17,
              color: "rgba(255,255,255,0.55)",
              lineHeight: 1.75,
              maxWidth: 640,
              marginBottom: 16,
              textAlign: "center",
            }}
          >
            A selection of platforms, operational systems, and digital products contributed to across previous engineering and leadership engagements spanning logistics, mobility, travel, and
            professional networking.
          </p>

          <p
            className="anim-fade-up-3"
            style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontSize: 13,
              color: "rgba(255,255,255,0.32)",
              lineHeight: 1.8,
              maxWidth: 580,
              letterSpacing: 0.2,
              textAlign: "center",
            }}
          >
            Projects shown represent selected engineering contributions, leadership initiatives, and product experience across previous collaborations and technical engagements.
          </p>
        </div>

        {/* divider */}
        <div className="anim-fade-in" style={{ maxWidth: 1200, margin: "64px auto 0", padding: "0 40px" }}>
          <div style={{ height: 1, background: "linear-gradient(90deg, rgba(52,79,107,0.6) 0%, rgba(52,79,107,0.2) 50%, transparent 100%)" }} />
        </div>
      </section>

      {/* ── PROJECT INTRO ── */}
      <section style={{ padding: "0 40px 60px" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <p style={{ fontFamily: "'Ubuntu', sans-serif", fontSize: 11, fontWeight: 600, color: "#344F6B", letterSpacing: 2.5, textTransform: "uppercase", marginBottom: 20 }}>
            Engineering Experience
          </p>
          <h2 style={{ fontFamily: "'Ubuntu', sans-serif", fontSize: 40, fontWeight: 700, color: "#FFFFFF", lineHeight: 1.2, letterSpacing: -1, marginBottom: 24, maxWidth: 700 }}>
            Experience across scalable platforms and operational systems.
          </h2>
          <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 16, lineHeight: 1.9, color: "rgba(255,255,255,0.58)", maxWidth: 720 }}>
            The following projects represent selected product engineering, architecture, and leadership contributions across previous collaborations and technical engagements. Experience spans mobile
            applications, logistics infrastructure, operational systems, real-time platforms, and scalable consumer products.
          </p>
        </div>
      </section>

      {/* ── PROJECTS ── */}
      <main>
        {projects.map((project, index) => {
          const isEven = index % 2 === 0;
          return (
            <section key={project.id} className="project-section" style={{ padding: "100px 0", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
              <div
                className="project-row"
                style={{
                  maxWidth: 1200,
                  margin: "0 auto",
                  padding: "0 40px",
                  display: "flex",
                  flexDirection: isEven ? "row" : "row-reverse",
                  alignItems: "center",
                  gap: 80,
                }}
              >
                <ProjectVisual project={project} />

                <div style={{ flex: 1, minWidth: 0 }}>
                  <span
                    style={{
                      fontFamily: "'Ubuntu', sans-serif",
                      fontSize: 11,
                      fontWeight: 500,
                      color: project.accent,
                      letterSpacing: 2.5,
                      textTransform: "uppercase",
                      display: "block",
                      marginBottom: 16,
                    }}
                  >
                    {project.category}
                  </span>
                  <h2 style={{ fontFamily: "'Ubuntu', sans-serif", fontSize: 40, fontWeight: 700, color: "#FFFFFF", lineHeight: 1.1, marginBottom: 24, letterSpacing: -1 }}>{project.title}</h2>
                  <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 15.5, lineHeight: 1.8, color: "rgba(255,255,255,0.6)", marginBottom: 36, maxWidth: 520 }}>
                    {project.description}
                  </p>

                  <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: project.links.length > 0 ? 36 : 0 }}>
                    {project.tech.map((t) => (
                      <span
                        key={t}
                        style={{
                          fontFamily: "'Plus Jakarta Sans', sans-serif",
                          fontSize: 12,
                          fontWeight: 500,
                          color: "rgba(255,255,255,0.5)",
                          background: "rgba(255,255,255,0.06)",
                          border: "1px solid rgba(255,255,255,0.09)",
                          borderRadius: 6,
                          padding: "5px 12px",
                        }}
                      >
                        {t}
                      </span>
                    ))}
                  </div>

                  {project.links.length > 0 && (
                    <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                      {project.links.map((link) => (
                        <LinkButton key={link.url} link={link} accent={project.accent} />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </section>
          );
        })}
      </main>

      <section style={{ padding: "120px 40px", borderTop: "1px solid rgba(255,255,255,0.06)" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 40 }}>
          <div>
            <p style={{ fontFamily: "'Ubuntu', sans-serif", fontSize: 11, fontWeight: 500, color: "#344F6B", letterSpacing: 2.5, textTransform: "uppercase", marginBottom: 16 }}>Start a Project</p>
            <h2 style={{ fontFamily: "'Ubuntu', sans-serif", fontSize: 48, fontWeight: 700, color: "#FFFFFF", lineHeight: 1.1, letterSpacing: -1.5, maxWidth: 500 }}>
              Building a product,
              <br />
              <span style={{ color: "rgba(255,255,255,0.35)" }}>platform, or operational system?</span>
            </h2>
            <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 15, lineHeight: 1.8, color: "rgba(255,255,255,0.45)", marginTop: 20, maxWidth: 520 }}>
              Let's discuss how Resovate can support your next initiative.
            </p>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16, alignItems: "flex-end" }}>
            <a
              href="/#contact"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 10,
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: 15,
                fontWeight: 600,
                color: "#0A0F1A",
                background: "#FFFFFF",
                border: "none",
                borderRadius: 10,
                padding: "16px 32px",
                textDecoration: "none",
                letterSpacing: 0.2,
                transition: "all 0.2s ease",
              }}
            >
              Let's Talk
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            <span style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.3)" }}>Typical response within 12 hours</span>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer style={{ borderTop: "1px solid rgba(255,255,255,0.06)", padding: "32px 40px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 16 }}>
        <span style={{ fontFamily: "'Ubuntu', sans-serif", fontSize: 16, fontWeight: 700, color: "#FFFFFF", letterSpacing: -0.5 }}>
          Resovate<span style={{ color: "rgba(255,255,255,0.3)", fontSize: 12, fontWeight: 400, marginLeft: 4 }}>Labs</span>
        </span>
        <span style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 13, color: "rgba(255,255,255,0.25)" }}>© {new Date().getFullYear()} Resovate Labs. All rights reserved.</span>
      </footer>
    </div>
  );
}
